module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.modName == 'home') ? _c('div', {
    model: {
      value: (_vm.pName),
      callback: function($$v) {
        _vm.pName = $$v
      },
      expression: "pName"
    }
  }, [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-copy",
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "bottom": "10px"
    }
  }, [_vm._v("\n        2011-2016 © iSenLoRa\n      ")])], 1) : _c('div', [_c('div', {
    staticClass: "layout-menu-left",
    class: {
      'layout-mobile-menu': _vm.leftHiden
    }
  }, [_c('Menu', {
    staticStyle: {
      "width": "199px !important"
    },
    attrs: {
      "theme": "dark"
    }
  }, _vm._l((_vm.leftLists), function(item, index) {
    return _c('Menu-item', {
      class: [_vm.currLeft[index] ? 'ivu-menu-item-active' : 'old-menu-bgc'],
      attrs: {
        "name": index + '-' + index
      },
      on: {
        "click": _vm.clickLeft
      },
      nativeOn: {
        "click": function($event) {
          _vm.goto('/' + item.url)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": item.icon
      }
    }), _vm._v("\n              " + _vm._s(item.name) + "\n              ")], 1)
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content-right ",
    class: {
      'layout-mobile-content': _vm.leftHiden
    }
  }, [_c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-copy"
  }, [_vm._v("\n          2011-2016 © iSenLoRa\n        ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c17949a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appContent.vue
// module id = 910
// module chunks = 1